import { t } from "i18next";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { cycleCamera } from "store/actions/devices";
import { useMobileDimension } from "utils/hooks";
import "./FlipCameraButton.scss";

const FlipCameraButton = (props) => {
  const dispatch = useDispatch();
  const [isMobileDimension] = useMobileDimension();
  const cameraMuteControlToggle = useSelector(
    (state) => state.config.urlCameraMuteControl.value
  );
  const devices = useSelector((state) => state.devices);

  const onClick = () => {
    dispatch(cycleCamera());
  };

  if (!cameraMuteControlToggle) {
    return null;
  }

  return (
    <div className="wrapper-flip-camera toogle-button-container">
      <button
        aria-label={t("FLIP_CAMERA")}
        className="flip-camera-button"
        onClick={onClick}
        disabled={!devices.isCameraTurnedOn}
      ></button>
      {!isMobileDimension && (
        <span className="toogle-button-label">{t("FLIP_CAMERA_DEVICE")}</span>
      )}
    </div>
  );
};

export default FlipCameraButton;
